import  { useEffect, useState } from 'react'
// import Submit from '../Submit'

import styled from 'styled-components'

import googleIcon from '../../assets/google-drive-icon.svg'

const Button = styled.div`
    font-size: 14px;
    line-height: 16px;
    color: #606060;

    display: flex;
    flex-direction: column;
    width: 124px;
    height: 92px;

    align-items: center;
    justify-content: center;

    background: rgba(255, 255, 255, 0.6);
    border-radius: 8px;

    cursor: pointer;
    background: rgba(255, 255, 255, 0.6);

    transition: background .2s;
    z-index: 1;

    &:hover {
        background: #F4F3F4;
    }

    &:first-child {
        margin-left: 0;
    }

    @media (min-width: 480px) {
        width: 96px;
    }
`
Button.displayName = 'Service-Button'

const Icon = styled.div`
    width: 48px;
    height: 48px;
    background-image: url(${googleIcon});
`
Icon.displayName = 'Service-Icon'


declare let window: any
let creatingPicker: boolean = false

// const scope = ['https://www.googleapis.com/auth/drive.file']
// const developerKey = "AIzaSyDgFV1Y95HDFI2RSBDme0qKLZcMoE5QRpE"
// const clientId = "773401989593-lln5k11l8espl9jhmi8908p5cn2dfphi.apps.googleusercontent.com"
// const appId = "773401989593"

const scope = 'https://www.googleapis.com/auth/drive.readonly'
const developerKey = "AIzaSyDgFV1Y95HDFI2RSBDme0qKLZcMoE5QRpE"
const clientId = "773401989593-lln5k11l8espl9jhmi8908p5cn2dfphi.apps.googleusercontent.com"
// const appId = "773401989593"

type Props = {
  callback: ({id, url, token}: {id: string, url: string, token: string})  => void,
};

const GoogleButton = ({ callback }: Props) => {
  const [oauthToken, setToken] = useState<string | undefined>(undefined)
  const [pickerLoaded, setPickerLoaded] = useState(false)
  


  function onPickerApiLoad() {
    setPickerLoaded(true);
  }

  function handleAuthResult(authResult: any) { // FIXME any
    setToken(authResult.access_token)
  }

  function onAuthApiLoad() {
    window.gapi.auth.authorize(
      {
        'client_id': clientId,
        'scope': scope,
        'immediate': false
      },
      handleAuthResult
    );
  }

  function loadPicker() {
    window.gapi.load('auth', {'callback': onAuthApiLoad});
    window.gapi.load('picker', {'callback': onPickerApiLoad});
  }

  async function pickerCallback(response: any) {
    if (response.action === 'picked' && oauthToken) {
      const googleFile = response.docs[0];
      callback({
        id: googleFile.id,
        url: googleFile.url,
        token: oauthToken,
      });
      if (creatingPicker) {
        setPickerLoaded(false)
        setToken(undefined)
      }
    }
    if (response.action === 'cancel') {
      if (creatingPicker) {
        setPickerLoaded(false)
        setToken(undefined)
      }
    }
  };

  useEffect(() => {
    if (pickerLoaded && oauthToken) {
      creatingPicker = true
      const createPicker = () => {
        var view = new window.google.picker.View(window.google.picker.ViewId.DOCS);
        view.setMimeTypes("application/pdf");

        var picker = new window.google.picker.PickerBuilder()
          .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
          .addView(view)
          .setOAuthToken(oauthToken)
          .setDeveloperKey(developerKey)
          .setCallback(pickerCallback)
          .build();

        picker.setVisible(true);
      }
      createPicker();
      return () => { creatingPicker = false }
    }
  }, [pickerLoaded, oauthToken])

  // return <Submit onClick={()=> loadPicker()}>
  //     Connect to Google Drive
  // </Submit>

  return <Button onClick={() => loadPicker()}>
    <Icon />
    Google Drive
  </Button>
}

export default GoogleButton
